module.exports = __webpack_public_path__ + "static/media/CaliforniaDrought.ded7fab9.jpg";